"use strict";
/* This is a generated file, do not edit */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserResult = void 0;
var Time_1 = require("../../builtin_interfaces/msg/Time");
var DispenserResult = /** @class */ (function () {
    function DispenserResult(fields) {
        if (fields === void 0) { fields = {}; }
        this.time = fields.time || new Time_1.Time();
        this.request_guid = fields.request_guid || '';
        this.source_guid = fields.source_guid || '';
        this.status = fields.status || 0;
    }
    DispenserResult.validate = function (obj) {
        try {
            Time_1.Time.validate(obj['time']);
        }
        catch (e) {
            throw new Error('in "time":\n  ' + e.message);
        }
        if (typeof obj['request_guid'] !== 'string') {
            throw new Error('expected "request_guid" to be "string"');
        }
        if (typeof obj['source_guid'] !== 'string') {
            throw new Error('expected "source_guid" to be "string"');
        }
        if (typeof obj['status'] !== 'number') {
            throw new Error('expected "status" to be "number"');
        }
    };
    DispenserResult.FullTypeName = 'rmf_dispenser_msgs/msg/DispenserResult';
    DispenserResult.ACKNOWLEDGED = 0;
    DispenserResult.SUCCESS = 1;
    DispenserResult.FAILED = 2;
    return DispenserResult;
}());
exports.DispenserResult = DispenserResult;
/*
builtin_interfaces/Time time

# A unique ID for the request which this result is for
string request_guid

# The unique ID of the workcell that this result was sent from
string source_guid

# Different basic result statuses
uint8 status
uint8 ACKNOWLEDGED=0
uint8 SUCCESS=1
uint8 FAILED=2

# below are custom workcell message fields

*/
